<table>
  <thead>
    <th>ID</th>
    <th>Point/Segment</th>
    <th>Route</th>
    <th>Name</th>
    <th>Type</th>
    <th>Labor</th>
    <th>Materials</th>
    <th>Length</th>
    <th>Total Cost</th>
  </thead>
  <tbody>

    <ng-container *ngFor="let feature of features;let feature_i=index">
      <tr *ngIf="IsNodeIncluded(feature)" [class.common-point]="IsPointInCommon(feature)"
        [class.native-point]="IsNativePoint(feature)" class="record-meta" [class.selected]="IsSelection(feature)"
        (click)="SelectRecord(feature,true)">
        <td class="cell-id">
          <div class="actions">
            <button class="jump-to-button btn btn-primary btn-md" (click)="JumpTo(feature)">
              <label>
                <span [innerText]="feature_i"></span><span *ngIf="!IsPointInCommon(feature)">:</span>
                <span *ngIf="!IsPointInCommon(feature)" [innerText]="FormatId(feature,feature_i)"></span>
              </label>
              <span class="fas fa-crosshairs"></span>
            </button>
          </div>
          <select [ngModel]="GetRouteID()" *ngIf="IsPointInCommon(feature)" class="form-select custom-select"
            (ngModelChange)="SwitchRoute($event,feature)">
            <option [ngValue]="route.id" *ngFor="let route of GetPointInCommonRoutes(feature)" [innerHTML]="route.name">
            </option>
          </select><!--<label *ngIf="IsPointInCommon(feature)"><span>:</span><span [innerText]="feature_i"></span></label>-->
          <div></div>
        </td>
        <td class="cell-geom-type" [innerText]="FormatGeomType(feature)"></td>
        <td class="cell-route" [innerText]="FormatRouteName(feature)"></td>
        <td class="cell-feature-name" [innerText]="FormatFeatureName(feature)"></td>
        <td class="cell-type" [innerText]="FormatType(feature)"></td>
        <td class="cell-labor" [innerText]="FormatLaborTotals(feature)"></td>
        <td class="cell-materials" [innerText]="FormatMaterialsTotals(feature)"></td>
        <td class="cell-length" [innerText]="FormatLength(feature)"></td>
        <td class="cell-total-cost" [innerText]="FormatTotalCost(feature)"></td>
      </tr>
      <tr *ngIf="IsNodeIncluded(feature)" class="attribute-data" [class.native-point]="IsNativePoint(feature)"
        [class.selected]="IsSelection(feature)">
        <td colspan="9">
          <div class="card-set" (click)="SelectRecord(feature)">
            <ng-container *ngFor="let attribute of GetFeatureData(feature)">
              <div class="card" data-guid="GetAttributeID(attribute)" *ngIf="IsDisplayableAttribute(attribute)"
                (click)="SelectRecord(feature)">
                <div class="attribute-name" [innerText]="FormatAttributeName(attribute)"></div>
                <div class="attribute-value" *ngIf="GetAttributeValueDisplayble(attribute)"
                  [innerText]="GetAttributeValue(attribute)"></div>
                <div class="attribute-costs" *ngIf="GetAttributeHasCosts(attribute,feature)">
                  <div class="labor-cost" *ngIf="GetAttributeHasCost(attribute,'labor',feature)">
                    <label>Labor:</label><span [innerText]="FormatAttributeCost(attribute,'labor',feature)"></span>
                  </div>
                  <div class="labor-materials" *ngIf="GetAttributeHasCost(attribute,'materials',feature)">
                    <label>Materials:</label><span
                      [innerText]="FormatAttributeCost(attribute,'materials',feature)"></span>
                  </div>
                </div>
                <div class="total-cost" *ngIf="GetAttributeHasCosts(attribute,feature)">
                  <label>Cost:</label><span [innerText]="FormatAttributeTotal(attribute,feature)"></span>
                </div>
              </div>
            </ng-container>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
